var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6923 10.9999C21.6923 5.47688 17.2153 0.999878 11.6923 0.999878C6.16926 0.999878 1.69226 5.47688 1.69226 10.9999C1.69226 16.5229 6.16926 20.9999 11.6923 20.9999",
    stroke: "#FCDEA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6923 1.04993C12.6923 1.04993 15.6923 4.99993 15.6923 10.9999M10.6923 20.9499C10.6923 20.9499 7.69227 16.9999 7.69227 10.9999C7.69227 4.99993 10.6923 1.04993 10.6923 1.04993M2.32227 14.4999H11.6923M2.32227 7.49993H21.0623",
    stroke: "#FCDEA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5712 16.9169C22.0652 17.2209 22.0342 17.9599 21.5262 18.0179L18.9592 18.3089L17.8082 20.6209C17.5802 21.0799 16.8752 20.8549 16.7582 20.2869L15.5032 14.1709C15.4042 13.6909 15.8362 13.3889 16.2532 13.6459L21.5712 16.9169Z",
    stroke: "#FCDEA2",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4d1f43c8f7228c88f11e9faa7804f691.svg";
export { ForwardRef as ReactComponent };